import 'react-multi-carousel/lib/styles.css';
import * as React from 'react';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Renewal from '../components/renewal/Renewal';
import { v1 } from 'uuid';
import ProductChat from '../components/product/ProductChat';
import ProductHeader from 'components/product/ProductHeader';
import ProgressBar from 'components/atomic/ProgressBar';
import { xVerifyService } from 'services';
import { checkEmail } from '../helpers/emailChecker';
import { usePrevious } from '../hooks';
import { NextSeo } from 'next-seo';
import { config } from '_config';
import {
  checkIfFileAllowed,
  getFileExtension,
  getFileExtensionsString,
  sanitizeFileName,
} from '../_helpers/utils';
import { useSelector } from 'react-redux';

const { apiUrl } = config;

const steps = ['Step 1', 'Step 2', 'Step 3', 'Step 4'];

const cardInfoInUse = {
  id: v1(),
  goods: 'true',
  clazz: null,
  goodsCategory: null,
  goodsServiceDetail: null,
  descriptions: [],
};
const cardInfoNotInUse = {
  id: v1(),
  goods: 'true',
  clazz: null,
  goodsCategory: null,
  goodsServiceDetail: null,
  descriptions: [],
};
const initialListInUse = [cardInfoInUse];
const initialListNotInUse = [cardInfoNotInUse];
export default function TrademarkRenewal() {
  const router = useRouter();
  const rightSide = useRef();
  const [imageSpecimen, setImageSpecimen] = React.useState();
  const [isImageSpecimenExist, setImageSpecimenExist] = React.useState(false);
  const [imageSpecimenSrc, setImageSpecimenSrc] = React.useState();
  const [allowedExtensions, setAllowedExtensions] = React.useState();
  const [allowedExtensionsArray, setAllowedExtensionsArray] =
    React.useState('');
  const [trademarkRushProcessing, setTrademarkRushProcessing] = useState({
    code: 'TRADEMARK_Trademark_Rush_Processing',
  });
  useEffect(() => {
    let salePage = window.location.href;
    let salePageURLArr = salePage.split('/');
    let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
      /\/+$/,
      ''
    );

    let url = apiUrl + '/category/products/' + state.code + '/file-types';
    let fallbackUrl =
      `${salePageURL}/crm` + '/category/products/' + state.code + '/file-types';
    axios
      .get(url, {
        params: { onlyForSale: false },
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        if (response.status === 200) {
          response.data
            .filter((file) => file.code.includes('TRADEMARK_SPECIMEN'))
            .forEach((allowedFile) => {
              setAllowedExtensions(
                getFileExtensionsString(allowedFile.allowedExtensions)
              );
              setAllowedExtensionsArray(allowedFile.allowedExtensions);
            });
        }
      });
  }, []);
  useEffect(() => {
    let salePage = window.location.href;
    let salePageURLArr = salePage.split('/');
    let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
      /\/+$/,
      ''
    );
    let url = apiUrl + '/category/TRADEMARKS/products/prices';
    let fallbackUrl =
      `${salePageURL}/crm` + '/category/TRADEMARKS/products/prices';

    axios
      .get(url, {
        params: { onlyForSale: false },
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        if (response.status === 200) {
          response.data
            .filter((product) =>
              product.code.code.includes('TRADEMARK_Trademark_Rush_Processing')
            )
            .forEach((rushTrademark) => {
              trademarkRushProcessing.price = rushTrademark.price;
              trademarkRushProcessing.customerName =
                rushTrademark.code.customerName;
              setTrademarkRushProcessing(trademarkRushProcessing);
            });
          const product = JSON.parse(localStorage.getItem('product'));
          const historyPath = localStorage.getItem('path');
          if (historyPath && historyPath === 'trademark-renewal' && product) {
            window.scrollTo(0, 0);
            setState({ ...product });
          }
        }
      })
      .catch((error) => {
        if (error.request) {
          axios
            .get(fallbackUrl, {
              params: { onlyForSale: false },
              headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
              if (response.status === 200) {
                response.data
                  .filter((product) =>
                    product.code.code.includes(
                      'TRADEMARK_Trademark_Rush_Processing'
                    )
                  )
                  .forEach((rushTrademark) => {
                    trademarkRushProcessing.price = rushTrademark.price;
                    trademarkRushProcessing.customerName =
                      rushTrademark.code.customerName;
                    setTrademarkRushProcessing(trademarkRushProcessing);
                  });
                const product = JSON.parse(localStorage.getItem('product'));
                const historyPath = localStorage.getItem('path');
                if (
                  historyPath &&
                  historyPath === 'trademark-renewal' &&
                  product
                ) {
                  window.scrollTo(0, 0);
                  setState({ ...product });
                }
              }
            });
        }
      });
  }, []);

  const [state, setState] = React.useState({
    code: 'TRADEMARK_Trademark_Renewal',
    serialProvided: 'true',
    serialNumber: null,
    markDesc: null,
    markOwnerFirstName: null,
    markOwnerLastName: null,
    markOwnerEmail: null,
    markOwnerPhone: null,
    inUseStatus: 'YES_ON_ALL',
    isNewName: 'true',
    isNewAddress: 'true',
    newFirstName: null,
    newLastName: null,
    newaddress: null,
    newcity: null,
    newstate: null,
    newzip: null,
    goodsAndServicesStillInUse: initialListInUse,
    goodsAndServicesNoLongerInUse: initialListNotInUse,
    trademarkRushType: 'TRADEMARK_Trademark_Rush_Processing',
    rushProcessing: true,
    firstName: null,
    lastName: null,
    phone: null,
    email: null,
    verifying: false,
    verificationResult: {},
    specimen: 'true',
    specimenURL: null,
    step: 0,
    isFileInvalidSize: '',
  });

  const prevState = usePrevious(state);

  const verifyEmail = useCallback(() => {
    if (!state.verificationResult?.email && checkEmail(state.email)) {
      setState((prevState) => ({ ...prevState, verifying: true }));

      xVerifyService.verifyEmail(state.email).then((result) => {
        setState((prevState) => {
          return {
            ...prevState,
            verificationResult: {
              ...prevState.verificationResult,
              email: result,
            },
            verifying: false,
          };
        });
      });
    }
  }, [state]);

  const verifyMarkOwnerEmail = useCallback(() => {
    if (
      !state.verificationResult?.markOwnerEmail &&
      checkEmail(state.markOwnerEmail)
    ) {
      setState((prevState) => ({ ...prevState, verifying: true }));

      xVerifyService.verifyEmail(state.markOwnerEmail).then((result) => {
        setState((prevState) => {
          return {
            ...prevState,
            verificationResult: {
              ...prevState.verificationResult,
              markOwnerEmail: result,
            },
            verifying: false,
          };
        });
      });
    }
  }, [state]);

  const handleBlur = useCallback(
    (e) => {
      const { type } = e.target;
      if (type === 'email' && state.step === 2) {
        verifyEmail();
      }
      if (type === 'email' && state.step === 0) {
        verifyMarkOwnerEmail();
      }
    },
    [state, verifyEmail, verifyMarkOwnerEmail]
  );

  function handleCategoriesStillInUse(classes) {
    setState({ ...state, goodsAndServicesStillInUse: classes });
    localStorage.setItem(
      'product',
      JSON.stringify({ ...state, goodsAndServicesStillInUse: classes })
    );
    localStorage.setItem('path', 'trademark-renewal');
  }

  function handleCategoriesNoLongerInUse(classes) {
    setState({ ...state, goodsAndServicesNoLongerInUse: classes });
    localStorage.setItem(
      'product',
      JSON.stringify({ ...state, goodsAndServicesNoLongerInUse: classes })
    );
    localStorage.setItem('path', 'trademark-renewal');
  }

  function handleChange(e) {
    if (e.target.name) {
      if (e.target.name === 'rushProcessing') {
        setState({ ...state, [e.target.name]: e.target.checked });
        localStorage.setItem(
          'product',
          JSON.stringify({ ...state, [e.target.name]: e.target.checked })
        );
      } else {
        if (e.target.type === 'email') {
          setState({
            ...state,
            [e.target.name]: e.target.value,
            verificationResult: {
              ...state.verificationResult,
              [e.target.name]: null,
            },
          });
          localStorage.setItem(
            'product',
            JSON.stringify({
              ...state,
              [e.target.name]: e.target.value,
              verificationResult: {
                ...state.verificationResult,
                [e.target.name]: null,
              },
            })
          );
        } else {
          setState({ ...state, [e.target.name]: e.target.value });
          localStorage.setItem(
            'product',
            JSON.stringify({ ...state, [e.target.name]: e.target.value })
          );
        }
      }
    } else {
      if (e.target.type === 'email') {
        setState({
          ...state,
          [e.target.id]: e.target.value,
          verificationResult: {
            ...state.verificationResult,
            [e.target.id]: null,
          },
        });
        localStorage.setItem(
          'product',
          JSON.stringify({
            ...state,
            [e.target.id]: e.target.value,
            verificationResult: {
              ...state.verificationResult,
              [e.target.id]: null,
            },
          })
        );
      } else if (e.target.type === 'file') {
        setState((prevState) => ({
          ...prevState,
          isFileInvalidSize: '',
        }));
        if (!e.target.files || e.target.files.length === 0) {
          setImageSpecimen(undefined);
        } else {
          const formFileExt = getFileExtension(e.target.files[0].name);
          const isExtensionAllowed = checkIfFileAllowed(
            formFileExt,
            allowedExtensionsArray
          );
          if (isExtensionAllowed) {
            const fileSize = e.target.files[0]?.size;
            if (fileSize && fileSize / 1024 / 1024 <= 5) {
              setImageSpecimen(e.target.files[0]);
            } else {
              setState((prevState) => ({
                ...prevState,
                isFileInvalidSize: 'File size limit is 5MB',
              }));
            }
          } else {
            setState((prevState) => ({
              ...prevState,
              isFileInvalidSize:
                'Incorrect file type. Allowed ' + allowedExtensions,
            }));
          }
        }
      } else {
        setState({ ...state, [e.target.id]: e.target.value });
        localStorage.setItem(
          'product',
          JSON.stringify({ ...state, [e.target.id]: e.target.value })
        );
      }
    }
    localStorage.setItem('path', 'trademark-renewal');
  }

  function handleStep(value) {
    setState({ ...state, step: value, isFileInvalidSize: false });
    localStorage.setItem('product', JSON.stringify({ ...state, step: value }));
    localStorage.setItem('path', 'trademark-renewal');
    router.push('/trademark-renewal?step=' + value, undefined, {
      shallow: true,
    });
  }

  useEffect(() => {
    if (!imageSpecimen) {
      setImageSpecimenSrc(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(imageSpecimen);
    setImageSpecimenSrc(objectUrl);
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [imageSpecimen]);

  useEffect(() => {
    if (router.query.step) {
      let newStep = parseInt(router.query.step, 10);
      if (
        newStep > 1 &&
        state.specimen === 'true' &&
        imageSpecimen === undefined
      ) {
        router.push('/trademark-renewal?step=1', undefined, {
          shallow: true,
        });
      } else {
        setState({ ...state, step: newStep });
      }
    }
  }, [router.query.step]);

  useEffect(() => {
    if (prevState?.email === null) {
      verifyEmail();
    }
    if (prevState?.markOwnerEmail === null) {
      verifyMarkOwnerEmail();
    }
  }, [prevState, state, verifyEmail, verifyMarkOwnerEmail]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      rightSide.current?.scrollIntoView();
    });

    return () => {
      clearTimeout(timeout);
    };
  }, [rightSide.current]);

  useEffect(() => {
    let timeout;

    function handleRouteChangeComplete() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      });
    }

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      clearTimeout(timeout);
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, []);

  return (
    <div className="reg" ref={config.skin === 'v2-basic' ? rightSide : null}>
      <NextSeo title="Filling a Renewal" />
      {config.skin === 'v2-basic' && (
        <div className="filing-banner-outer-container">
          <div className="filing-banner-inner-container">
            <ProductHeader header="Renewal Filing" />
            <ProgressBar value={state.step + 1} maxValue={steps.length} />
          </div>
        </div>
      )}
      <div className="side-wrapper">
        <div className="left-side">
          <div className="banner">
            <div className="summary">
              <h3>Trademark Renewal Summary</h3>
              <div className="step-box">
                {state.serialProvided === 'true' ? (
                  <>
                    <h5>SERIAL NUMBER</h5>
                    <p>{state.serialNumber}</p>
                  </>
                ) : (
                  <>
                    <h5>OWNER OF MARK {state.markDesc}</h5>
                    <p>
                      {state.markOwnerFirstName ? state.markOwnerFirstName : ''}{' '}
                      {state.markOwnerLastName ? state.markOwnerLastName : ''}
                    </p>
                    <p>
                      {state.markOwnerPhone ? state.markOwnerPhone : ''}{' '}
                      {state.markOwnerEmail ? state.markOwnerEmail : ''}
                    </p>
                  </>
                )}
              </div>
              {state.step > 1 && (
                <div className="step-box">
                  <h5>YOUR ACCOUNT</h5>
                  <p>
                    {state.firstName ? state.firstName : ''}{' '}
                    {state.lastName ? state.lastName : ''}
                  </p>
                  <p>
                    {state.phone ? state.phone : ''}{' '}
                    {state.email ? state.email : ''}
                  </p>
                </div>
              )}
              {state.step > 2 && state.rushProcessing && (
                <div className="step-box">
                  <h5>THE PROCESSING SPEED</h5>
                  <p>
                    Rush Priority Processing. Next day processing when you need
                    mark filed quickly.
                  </p>
                </div>
              )}
              <ProductChat />
            </div>
          </div>
        </div>
        <div
          className="right-side"
          id="rightSide"
          ref={config.skin === 'v2-basic' ? null : rightSide}
        >
          <div className="form">
            <Renewal
              state={state}
              onChange={handleChange}
              onBlur={handleBlur}
              onStep={handleStep}
              trademarkRushProcessing={trademarkRushProcessing}
              onHandleCategoriesStillInUse={handleCategoriesStillInUse}
              onHandleCategoriesNoLongerInUse={handleCategoriesNoLongerInUse}
              imageSpecimen={imageSpecimen}
              imageSpecimenSrc={imageSpecimenSrc}
              allowedExtensions={allowedExtensions}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
